import { render, staticRenderFns } from "./OrderRequest.vue?vue&type=template&id=40824084&scoped=true"
import script from "./OrderRequest.vue?vue&type=script&lang=js"
export * from "./OrderRequest.vue?vue&type=script&lang=js"
import style0 from "./OrderRequest.vue?vue&type=style&index=0&id=40824084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40824084",
  null
  
)

export default component.exports